// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1fQBq","colMin":"styles_colMin__2e4_B","colCheckbox":"styles_colCheckbox__334K5"};